import moment from "moment"

export default {
	state: {
		statusValues: {
			pending: 0,
			scheduled: 1,
			completed: 2,
			cancelled: 3,
			unconfirmed: 4,
			unpublished: 5,
			error: 6,
		},
		statusColors: ["pending", "scheduled", "completed", "cancelled", "unconfirmed", "unpublished", "error"],
		shifts: [],
		availableShifts: [],
		timeClockShifts: [],
		notifiedStaffs: [],
		cancellationPolicies: [],
		cancellationReasons: [],
		date: {}
	},

	actions: {
		getShiftsForRange(actionContext, parameters) {
			return new Promise(async (resolve, reject) => {
				try {
					if (parameters.showLoading)
						actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile
					var customers = actionContext.rootState.Customers.customers

					if (customers.length < 1)
						await actionContext.dispatch("Customers/getCustomers", null, { root: true }).then(() => {
							customers = actionContext.rootState.Customers.customers
						})

					var getMoreShifts = true
					var shifts = []
					var extraInformationForShifts = []

					while (getMoreShifts) {
						await actionContext.dispatch("getShifts", parameters)
							.then(records => {
								Array.prototype.push.apply(shifts, records)

								if (records.length >= 100) {
									parameters.toDate = moment(records[records.length - 1].servicedate, "D/MM/YYYY h:mm:ss A").format("YYYY-MM-DD")
								}

								if (records.length < 100) {
									shifts = shifts.filter((v, i, a) => a.findIndex(v2 => (v2.servicescheduleid === v.servicescheduleid)) === i)

									shifts = shifts
										.sort(actionContext.rootGetters["Helper/compareValues"](
											"servicedate",
											"asc",
											(val) => { return moment(val, "D/MM/YYYY h:mm:ss A").toDate() }))
										
									actionContext.commit(
										"setShifts",
										{
											shifts: shifts,
											autopublishshifts: profile.autopublishshifts,
											customers: customers,
											accounttype: profile.accounttype
										}
									)

									getMoreShifts = false

									if (parameters.showLoading)
										actionContext.commit("Loading/hide", null, { root: true })

									resolve()
								}
							})
							.catch(response => {
								actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })

								if (parameters.showLoading)
									actionContext.commit("Loading/hide", null, { root: true })

								reject(response)
							})
					}
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })

					if (parameters.showLoading)
						actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getAvailableShifts(actionContext, parameters) {
			return new Promise(async (resolve, reject) => {
				try {
					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/AvailableShifts?userid=${profile.userid}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setAvailableShifts", records)

							resolve(records)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })

							if (parameters.showLoading)
								actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })

					if (parameters.showLoading)
						actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getShifts(actionContext, parameters) {
			return new Promise(async (resolve, reject) => {
				try {
					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/Timesheets?accounttype=${profile.accounttype}&userid=${profile.userid}&fromdate=${parameters.fromDate}&todate=${parameters.toDate}&disregardStatusFilter=true`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							resolve(records)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })

							if (parameters.showLoading)
								actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })

					if (parameters.showLoading)
						actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		saveShift(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].post("Service/SaveShift", parameters)
						.then(response => {
							if (response.data.errors != "") {
								actionContext.commit("Toasts/showWarning", { title: "Shift Error", content: response.data.errors }, { root: true })
								actionContext.commit("Loading/hide", null, { root: true })
							}

							actionContext.commit("Toasts/showSuccess", { title: "Saved", content: "Shift saved!" }, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve(response.data)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		createTimesheet(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].post("Service/CreateTimesheet", parameters)
						.then(response => {
							if (response.data.errors != "") {
								actionContext.commit("Toasts/showWarning", { title: "Shift Error", content: response.data.errors }, { root: true })
								actionContext.commit("Loading/hide", null, { root: true })

								resolve(response.data)

								return
							}

							actionContext.dispatch(
								"SaveTimesheet",
								{
									userId: parameters.userId,
									timesheetId: response.data.timesheetid,
									serviceScheduleId: response.data.shiftid,
									timesheetFrom: parameters.dateFrom,
									timesheetUntil: parameters.dateTo,
									timesheetLunchBreak: 0,
									vehicleId: parameters.vehicle,
									vehicleRegistrationNumber: parameters.vehicleRegistrationNumber,
									odometerStart: parameters.odometerStart,
									odometerEnd: parameters.odometerEnd,
									timesheetTravelDistance: parameters.travelKm,
									timesheetTransportDistance: parameters.transportKm,
									timesheetTravelTime: 0,
									timesheetComments: "",
									shiftNotes: parameters.notes,
									timesheetApproved: 0,
									hasConcerns: 0,
									usedCompanyCar: parameters.usedCompanyCar
								})
								.then(() => {
									actionContext.commit("Toasts/showSuccess", { title: "Saved", content: "Shift and Timesheet saved!" }, { root: true })
									actionContext.commit("Loading/hide", null, { root: true })

									resolve(response.data)
								})
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		SaveTimesheet(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].post("Service/SaveTimesheet", parameters)
						.then(response => {
							actionContext.commit("Toasts/showSuccess", { title: "Saved", content: "Timesheet saved!" }, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve(response.data)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		cancelShifts(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/CancelShifts?ids=${parameters.ids}&reason=${parameters.cancellationReasonId}&comments=${parameters.comments}&cancellationpolicyid=${parameters.cancellationPolicyId}`)
						.then(response => {
							actionContext.commit("Toasts/showSuccess", { title: "Cancelled", content: "Shift cancelled!" }, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve(response.data)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		saveShiftNotes(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/SaveShiftNotes?serviceScheduleId=${parameters.serviceScheduleId}&shiftNotes=${parameters.notes}`)
						.then(response => {
							actionContext.commit("setShiftNotes", parameters)
							actionContext.commit("Toasts/showSuccess", { title: "Saved", content: "Shift notes saved!" }, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve(response.data)
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getCancellationPolicies(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "" +
						"cp.id, " +
						"cp.name, " +
						"cp.description, " +
						"cp.chargepercentage, " +
						"cp.maxpaymenthours, " +
						"cp.chargetype";

					var tableName = "" +
						"@db.cancellationpolicy cp ";

					var filter = "" +
						"cp.inactive = 0";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?tableName=${tableName}&columns=${columns}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setCancellationPolicies", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getCancellationReasons(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get("Service/GetCancellationReasons")
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setCancellationReasons", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		DeleteShift(actionContext, parameters) {
			return new Promise(async (resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					if (parameters.timesheetId)
						await actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/DeleteTableRecord?tableName=timesheet&recordId=${parameters.timesheetId}`)
							.catch(response => {
								actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
								actionContext.commit("Loading/hide", null, { root: true })

								reject(response)
							})

					var columns = "" +
						"ssc.id as servicescheduleclientid"
						+ ", sse.id as servicescheduleemployeeid";

					var tableName = "" +
						"@db.serviceschedule ss"
						+ " left join @db.servicescheduleclient ssc on ss.id = ssc.servicescheduleid"
						+ " left join @db.servicescheduleemployee sse on ss.id = sse.servicescheduleid";

					var filter = "" +
						"ss.id = " + parameters.serviceScheduleId;

					await actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?tableName=${tableName}&columns=${columns}&filter=${filter}`)
						.then(async (response) => {
							var record = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)[0]

							await actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/DeleteTableRecord?tableName=servicescheduleclient&recordId=${record.servicescheduleclientid}`)
								.catch(response => {
									actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
									actionContext.commit("Loading/hide", null, { root: true })

									reject(response)
								})

							if (record.servicescheduleemployeeid) {
								await actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/DeleteTableRecord?tableName=servicescheduleemployee&recordId=${record.servicescheduleemployeeid}`)
									.catch(response => {
										actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
										actionContext.commit("Loading/hide", null, { root: true })

										reject(response)
									})
							}
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/DeleteTableRecord?tableName=serviceschedule&recordId=${parameters.serviceScheduleId}`)
						.then(response => {
							actionContext.commit("Toasts/showSuccess", { title: "Deleted", content: "Shift deleted!" }, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		publishShiftAvailability(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"]
						.post(
							"Service/publishShiftAvailability",
							{
								ids: parameters.ids,
								uids: parameters.uids,
								notify: true,
								smsnotify: parameters.sendSms,
								moderation: 0
							}
						)
						.then(response => {
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		pickupShift(actionContext, shiftid) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/PickupShift?serviceScheduleId=${shiftid}&userId=${profile.userid}`)
						.then(response => {
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		getNotifiedStaffDetails(actionContext, shiftid) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "" +
						"u.name";

					var tableName = "" +
						"@db.serviceschedule ss "
						+ " inner join @db.user u on find_in_set(u.id, ss.notifiedstaffs)";

					var filter = "" +
						`ss.id = ${shiftid}`
						+ " order by u.name asc";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?tableName=${tableName}&columns=${columns}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setNotifiedStaffs", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setCancellationPolicies(state, cancellationPolicies) {
			state.cancellationPolicies = cancellationPolicies
		},
		setCancellationReasons(state, cancellationReasons) {
			state.cancellationReasons = cancellationReasons
		},
		setShifts(state, obj) {
			var customerIds = obj.customers.map(x => x.id)
			var shifts = JSON.parse(JSON.stringify(obj.shifts))

			state.shifts = shifts
				.filter(shift => {
					return obj.accounttype == 3
						|| customerIds.indexOf(shift.clientid) > -1
				})
				.map((shift, index) => {
					shift.allStatuses = shift.status
					shift.statusColor = state.statusColors[shift.status]
					shift.error = (shift.errors || "").replaceAll("<li>", "").replaceAll("</li>", "\n")
					shift.totalhours = shift.totalhours == "0.00" ? moment(shift.enddate, "DD/MM/YYYY h:mm:ss A").diff(moment(shift.servicedate, "DD/MM/YYYY h:mm:ss A"), "hours", true) : shift.totalhours
					
					if (!obj.autopublishshifts && shift.ispublished == "0") {
						shift.allStatuses = state.statusValues.unpublished
						shift.statusColor = state.statusColors[5]
					}

					if (shift.employeeid == "0") {
						shift.allStatuses = state.statusValues.unconfirmed
						shift.statusColor = state.statusColors[state.statusValues.unconfirmed]
					}

					if (shift.status == "3") {
						shift.allStatuses = state.statusValues.cancelled
						shift.statusColor = state.statusColors[state.statusValues.cancelled]
					}

					if ((shift.servicetypename + "").toLowerCase().indexOf("overnight") < 0
						&& moment(shift.enddate, "DD/MM/YYYY h:mm:ss A").diff(moment(shift.servicedate, "DD/MM/YYYY h:mm:ss A"), "hours", true) > 8) {
						shift.error = "Shift duration more than 8 hours"
					}

					if (shift.error.length > 0) {
						shift.allStatuses = state.statusValues.error
						shift.statusColor = state.statusColors[state.statusValues.error]
					}

					if ((shift.shifttask + "").indexOf(shift.servicetypename) < 0) {
						shift.shiftname = `${shift.shifttask} - ${shift.servicetypename}`;
					}
					else {
						shift.shiftname = shift.shifttask;
					}

					shift.istimeclock = shift.shiftcomments == "TimeClock"

					return shift
				})
			
			shifts = JSON.parse(JSON.stringify(obj.shifts))

			state.timeClockShifts = shifts
				.slice()
				.filter(shift => {
					return customerIds.indexOf(shift.clientid) > -1
						&& shift.shiftcomments == "TimeClock"
				})
				.map((shift, index) => {
					shift.allStatuses = shift.status
					shift.statusColor = state.statusColors[shift.status]

					if (!obj.autopublishshifts && shift.ispublished == "0") {
						shift.allStatuses = state.statusValues.unpublished
						shift.statusColor = state.statusColors[5]
					}

					if (shift.employeeid == "0") {
						shift.allStatuses = state.statusValues.unconfirmed
						shift.statusColor = state.statusColors[state.statusValues.unconfirmed]
					}

					if (shift.status == "3") {
						shift.allStatuses = state.statusValues.cancelled
						shift.statusColor = state.statusColors[state.statusValues.cancelled]
					}

					return shift
				})
		},
		setAvailableShifts(state, availableShifts) {
			state.availableShifts = availableShifts.map(shift => {
				shift.shifttotalhours = moment(shift.serviceenddate, "DD/MM/YYYY h:mm:ss A").diff(moment(shift.servicedate, "DD/MM/YYYY h:mm:ss A"), "hours", true)

				return shift
			})
		},
		setNotifiedStaffs(state, notifiedStaffs) {
			state.notifiedStaffs = notifiedStaffs
		},
		setShiftNotes(state, obj) {
			state.shifts.filter(x => x.servicescheduleid == obj.serviceScheduleId)[0].shiftnotes = obj.notes
		},
		setDate(state, date) {
			state.date = date
		}
	},

	getters: {
		currentTimeClockShift: function (state) {
			var currentTimeClockShift = null

			if (state.timeClockShifts != null && state.timeClockShifts.length > 0) {
				currentTimeClockShift = state.timeClockShifts.filter(x => {
					var startTime = moment(x.servicedate, "DD/MM/YYYY h:mm:ss A")

					return moment().isSameOrAfter(startTime) && x.clockouttime == ""
				})[0]
			}

			return currentTimeClockShift
		},
	},

	namespaced: true
}